module.exports = __webpack_public_path__ + "img/56-green.e03049ae.svg";